import { render } from "./LiquidityPoolExplorer.vue?vue&type=template&id=492393a6&scoped=true"
import script from "./LiquidityPoolExplorer.vue?vue&type=script&lang=js"
export * from "./LiquidityPoolExplorer.vue?vue&type=script&lang=js"

import "./LiquidityPoolExplorer.vue?vue&type=style&index=0&id=492393a6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492393a6"],['__file',"resources/js/components/defi/LiquidityPoolExplorer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "492393a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('492393a6', __exports__)) {
    api.reload('492393a6', __exports__)
  }
  
  module.hot.accept("./LiquidityPoolExplorer.vue?vue&type=template&id=492393a6&scoped=true", () => {
    api.rerender('492393a6', render)
  })

}


export default __exports__